import React from 'react';
import {ContentWrapper, InfoOriginalNameWrapper, InfoTextWrapper, TextWrapper} from './FileBasicData.style';

import {t} from 'i18next';
import {formatDate, formatFiletype, formatSize} from '../../../utils';
import {StorageObject} from '../../../models/StorageObject';
import {generateIdentifier} from '../../../utils/IdentityUtils';
import {TemplatePropertySettings} from '../../../models/TemplatePropertySettings';
import {isVisibleComponent} from '../../../utils/TemplateUtils';
import {
    STORAGE_OBJECT_NAME,
    STORAGE_OBJECT_OBJECT_METADATA,
    STORAGE_OBJECT_OBJECT_METADATA_CONTENT_TYPE,
    STORAGE_OBJECT_OBJECT_METADATA_DATE_CREATED,
    STORAGE_OBJECT_OBJECT_METADATA_DATE_UPDATED,
    STORAGE_OBJECT_TOTAL_SIZE
} from '../../../init/storage_object_constants';

export interface FileBasicDataProps {
    readonly templatePropertySettings: Map<string, TemplatePropertySettings>;
    readonly language: string;
    readonly item: StorageObject;
}

export const FileBasicData: React.VFC<FileBasicDataProps> = (props) => {
    return (
        <ContentWrapper id={generateIdentifier()}>
            {isVisibleComponent(STORAGE_OBJECT_NAME, props.templatePropertySettings) &&
                <InfoOriginalNameWrapper id={generateIdentifier()}>
                    <TextWrapper id={generateIdentifier()}>
                        {t('UPLOAD_FILE_META_DATA_DIALOG_ORIGINAL_NAME_INFO_TEXT', {name: props.item.name})}
                    </TextWrapper>
                </InfoOriginalNameWrapper>
            }
            {(isVisibleComponent(STORAGE_OBJECT_OBJECT_METADATA_CONTENT_TYPE, props.templatePropertySettings)
                    || isVisibleComponent(STORAGE_OBJECT_TOTAL_SIZE, props.templatePropertySettings)) &&
                <InfoTextWrapper id={generateIdentifier()}>
                    {(isVisibleComponent(STORAGE_OBJECT_OBJECT_METADATA, props.templatePropertySettings)
                            && isVisibleComponent(STORAGE_OBJECT_OBJECT_METADATA_CONTENT_TYPE, props.templatePropertySettings)) &&
                        <TextWrapper id={generateIdentifier()}>
                            {t('UPLOAD_FILE_META_DATA_DIALOG_FILE_TYPE_INFO_TEXT',
                                {type: formatFiletype(props.item.metadata.contentType)})}
                        </TextWrapper>
                    }
                    {isVisibleComponent(STORAGE_OBJECT_TOTAL_SIZE, props.templatePropertySettings) &&
                        <TextWrapper id={generateIdentifier()}>
                            {t('UPLOAD_FILE_META_DATA_DIALOG_FILE_SIZE_INFO_TEXT',
                                {size: formatSize(props.item.totalSize)})}
                        </TextWrapper>
                    }
                </InfoTextWrapper>
            }
            <div id={generateIdentifier()}/>
            {(isVisibleComponent(STORAGE_OBJECT_OBJECT_METADATA, props.templatePropertySettings)
                    && (isVisibleComponent(STORAGE_OBJECT_OBJECT_METADATA_DATE_CREATED, props.templatePropertySettings)
                        || isVisibleComponent(STORAGE_OBJECT_OBJECT_METADATA_DATE_UPDATED, props.templatePropertySettings))) &&
                <InfoTextWrapper id={generateIdentifier()}>
                    {isVisibleComponent(STORAGE_OBJECT_OBJECT_METADATA_DATE_CREATED, props.templatePropertySettings) &&
                        <TextWrapper id={generateIdentifier()}>
                            {t('UPLOAD_FILE_META_DATA_DIALOG_DATE_CREATED_INFO_TEXT', {date: formatDate(props.language, props.item.metadata.dateCreated)})}
                        </TextWrapper>
                    }
                    {isVisibleComponent(STORAGE_OBJECT_OBJECT_METADATA_DATE_UPDATED, props.templatePropertySettings) &&
                        <TextWrapper id={generateIdentifier()}>
                            {t('UPLOAD_FILE_META_DATA_DIALOG_DATE_UPDATED_INFO_TEXT', {date: formatDate(props.language, props.item.metadata.dateUpdated)})}
                        </TextWrapper>
                    }
                </InfoTextWrapper>
            }
        </ContentWrapper>
    );
};
